// Service prefixes for Gateway routing
// Use /api prefix in development to match Vite proxy, keep original prefix for production
const isDev = import.meta.env.MODE === 'development';
export const API_SERVICES = {
  FOXIA_ID: '/foxia-id',      // foxia-id backend
  ANALYTIC: isDev ? '/api/analytic' : '/analytic', // analytics backend (future)
  CRM: '/crm',                 // CRM backend (future)
  ORDER: '/order',             // Order backend (future)
};
